var exports = {
  "k": "x804f0401--cf90f1--container",
  "x": "x804f0401--cf90f1--button",
};

module.exports = exports;
